var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosProfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#00BFA5",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5410_16368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.804 14.0375C38.728 14.0576 38.5758 14.1336 38.4597 14.2057C37.8151 14.6181 37.5909 15.4189 37.9272 16.1075C38.0553 16.3638 38.3556 16.6561 38.6319 16.7842L38.8601 16.8923L40.2695 16.9123L41.6748 16.9324L39.4527 19.3347C38.2275 20.656 37.0263 21.9532 36.7821 22.2215C36.5378 22.4857 35.5649 23.5348 34.62 24.5557L32.9023 26.4055L30.9364 24.4436C28.6462 22.1614 28.7743 22.2575 28.0696 22.2575C27.3489 22.2575 27.6732 21.9652 23.7494 26.1973C21.8836 28.2153 20.3021 29.921 20.238 29.989C20.174 30.0611 18.9248 31.4064 17.4593 32.9839C15.5174 35.074 14.7607 35.9188 14.6566 36.099C14.5365 36.3152 14.5165 36.3912 14.5045 36.6915C14.4844 37.0919 14.5285 37.2721 14.7047 37.5724C15.069 38.177 15.8938 38.4172 16.5665 38.1169C16.7546 38.0288 16.8948 37.9207 17.167 37.6364C17.5754 37.216 17.5634 37.224 21.3231 33.1681C22.8846 31.4825 25.0507 29.1442 26.1398 27.9711L28.1217 25.837L30.0876 27.7989C31.8253 29.5326 32.0815 29.7728 32.2937 29.8689C32.7462 30.0771 33.3387 30.0411 33.7471 29.7768C33.8432 29.7128 35.4047 28.0632 37.3106 26.0012C39.1764 23.9872 40.9742 22.0493 41.3025 21.697C41.6348 21.3446 42.2834 20.644 42.7439 20.1435L43.5847 19.2306L43.6047 20.4438L43.6247 21.6609L43.7569 21.9252C43.9611 22.3456 44.3374 22.6219 44.8299 22.718C45.4385 22.8381 46.1031 22.4897 46.4074 21.8932L46.5075 21.697V18.3537V15.0105L46.3714 14.7582C46.2072 14.4579 45.995 14.2578 45.6907 14.1136L45.4665 14.0095L42.2033 14.0015C40.1534 13.9975 38.8881 14.0095 38.804 14.0375Z",
    fill: "#00BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4686 43.1733C15.0802 43.3054 14.8239 43.5296 14.6237 43.914C14.5236 44.0982 14.5156 44.1582 14.5156 44.5586C14.5156 44.963 14.5236 45.015 14.6317 45.2272C14.7719 45.5035 15.0081 45.7397 15.2964 45.8879L15.5166 46H30.5112H45.5057L45.7379 45.8799C46.0062 45.7478 46.2745 45.4675 46.4146 45.1872C46.4947 45.0231 46.5067 44.939 46.5067 44.5586C46.5067 44.1342 46.5027 44.1102 46.3705 43.8659C46.2104 43.5696 45.9982 43.3694 45.6859 43.2213L45.4657 43.1172L30.5712 43.1092C16.3214 43.1012 15.6687 43.1012 15.4686 43.1733Z",
    fill: "#00BFA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5410_16368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12.6641 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosProfit);
export default __webpack_public_path__ + "static/media/pos_profit.aabba702b40a946e0550e55f6d423d7e.svg";
export { ForwardRef as ReactComponent };